import React from "react";
import { Mail, Phone, ExternalLink } from "lucide-react";
import "./MatchWaitlist.css";

export default function OrganizerContact({ match, contact, preview = false }) {
  const value = contact || (match?.competitorInfo?.publicationState === "published" ? match.competitorInfo.organizerContact : null);
  if (!value || !Object.values(value).some(Boolean)) return null;
  const email = typeof value.email === "string" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.email) ? value.email : "";
  const phone = typeof value.phone === "string" && /^[+\d\s().-]{3,40}$/.test(value.phone) ? value.phone : "";
  let website = "";
  try { const url = new URL(value.website); if (["http:", "https:"].includes(url.protocol) && !url.username && !url.password) website = url.href; } catch {}
  return <section className="organizer-contact" aria-label="Organizer contact"><h3>{preview ? "Organizer contact preview" : "Contact the organizer"}</h3>{value.name && <p>{value.name}</p>}<div>
    {email && <a href={`mailto:${encodeURIComponent(email)}`}><Mail size={16} aria-hidden="true" />{email}</a>}
    {phone && <a href={`tel:${phone.replace(/[^+\d]/g, "")}`}><Phone size={16} aria-hidden="true" />{phone}</a>}
    {website && <a href={website} target="_blank" rel="noopener noreferrer"><ExternalLink size={16} aria-hidden="true" />Organizer website</a>}
  </div></section>;
}
